import React from 'react';
import { Link } from 'react-router-dom';
import { FaStar } from 'react-icons/fa';
import './NewArrivals.css';

const NewArrivals = () => {
  const products = [
    {
      name: 'Premium Hi-Fi Floor Standing Speakers',
      brand: 'Bowers & Wilkins',
      price: 'Contact for Price',
      image: 'https://images.unsplash.com/photo-1545454660-877a4a8c4a9e?w=600&h=600&fit=crop&q=80',
      tag: 'New Arrival',
      features: ['3-Way Design', 'Diamond Dome Tweeter', 'Continuum Cone']
    },
    {
      name: 'Luxury Home Theater Processor',
      brand: 'McIntosh',
      price: 'Contact for Price',
      image: 'https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=600&h=600&fit=crop&q=80',
      tag: 'New Arrival',
      features: ['16 Channel Processing', '4K/8K Support', 'Room Correction']
    },
    {
      name: 'Wireless Surround Sound System',
      brand: 'Focal',
      price: 'Contact for Price',
      image: 'https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?w=600&h=600&fit=crop&q=80',
      tag: 'New Arrival',
      features: ['Wireless Connectivity', 'Dolby Atmos', 'Voice Control']
    },
    {
      name: 'Premium Subwoofer',
      brand: 'JL Audio',
      price: 'Contact for Price',
      image: 'https://images.unsplash.com/photo-1558584673-c834fb1cc3ca?w=600&h=600&fit=crop&q=80',
      tag: 'New Arrival',
      features: ['12" Driver', '1500W RMS', 'Sealed Enclosure']
    },
    {
      name: 'Bookshelf Speaker System',
      brand: 'Dali',
      price: 'Contact for Price',
      image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=600&h=600&fit=crop&q=80',
      tag: 'New Arrival',
      features: ['2-Way Design', 'Hybrid Tweeter', 'Wood Veneer']
    },
    {
      name: 'Smart Home Audio Hub',
      brand: 'GoldenEar',
      price: 'Contact for Price',
      image: 'https://images.unsplash.com/photo-1589003077984-894e133dabab?w=600&h=600&fit=crop&q=80',
      tag: 'New Arrival',
      features: ['Multi-Room Audio', 'Streaming Support', 'Voice Assistant']
    }
  ];

  return (
    <div className="new-arrivals-page">
      {/* Hero Section */}
      <section className="arrivals-hero">
        <div className="arrivals-hero-overlay"></div>
        <div className="arrivals-hero-content">
          <h1>New Arrivals</h1>
          <p>Discover the latest premium audio equipment and cutting-edge technology</p>
        </div>
      </section>

      {/* Products Section */}
      <section className="arrivals-products">
        <div className="container">
          <div className="section-header">
            
          </div>

          <div className="products-grid">
            {products.map((product, index) => (
              <div className="product-card" key={index}>
                <div className="product-image">
                  <img src={product.image} alt={product.name} />
                  <span className="product-tag">{product.tag}</span>
                </div>
                <div className="product-details">
                  <span className="product-brand">{product.brand}</span>
                  <h3>{product.name}</h3>
                  <ul className="product-features">
                    {product.features.map((feature, idx) => (
                      <li key={idx}>
                        <FaStar /> {feature}
                      </li>
                    ))}
                  </ul>
                  <div className="product-footer">
                    <span className="product-price">{product.price}</span>
                    <Link to="/contact" className="btn-enquire">Enquire Now</Link>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="arrivals-cta">
            <h3>Interested in These Products?</h3>
            <p>Contact our experts to learn more about pricing, availability, and installation</p>
            <div className="cta-buttons">
              <Link to="/contact" className="btn btn-primary">Get in Touch</Link>
              <a href="tel:+919876543210" className="btn btn-secondary">Call Now</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NewArrivals;
